// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1___e22d99181a7356bf71c","cls2":"SimplePaperPodcast-cls2___503c96451f565077af1 SimplePaperPodcast-cls1___e22d99181a7356bf71c"};